import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { compose } from 'recompose';
import { t } from '../../../modules/infra/i18n';

import Settings from '../../main/settings/settings';
import BrandSettings from '../../main/settings/brandSettings/containers/BrandSettings';
import Taxes from './brandUserTaxesContainer';
import ChangePassword from '../../main/settings/changePassword/changePassword';
import { getBrandId } from '../../auth/selectors';
import BrandPaymentSettings from '../../main/settings/brandSettings/components/BrandPaymentSettings';
import { canUserViewTaxes } from '../../common/helpers/users';
import withPermissions from '../../auth/utils/withPermissions';
import { UserSettings } from '../../../modules/shared/auth/two-fa/user-settings';

class BrandUserSettingsWrapper extends Component {
  getPages = () => ({
    details: {
      component: (<BrandSettings />),
      title: t('settings:pages.brand_settings'),
    },
    taxes: {
      component: (<Taxes />),
      title: t('settings:pages.taxes'),
      displayIf: canUserViewTaxes(this.props.permissions),
    },
    'change-password': {
      component: (<ChangePassword />),
      title: t('settings:pages.change_password'),
    },
    user: {
      component: (<UserSettings />),
      title: t('settings:pages.user_settings'),
    },
    'payment-card': {
      component: (<BrandPaymentSettings />),
      title: t('settings:pages.subscription'),
    },
  });

  render() {
    const { page } = this.props;

    return (
      <Settings
        pages={this.getPages()}
        page={page}
      />
    );
  }
}

BrandUserSettingsWrapper.propTypes = {
  page: PropTypes.string,
  brandId: PropTypes.string.isRequired,
  permissions: PropTypes.shape({}).isRequired,
};
BrandUserSettingsWrapper.defaultProps = {
  page: '',
};

const mapStateToProps = (state, ownProps) => ({
  page: ownProps.params.page,
  brandId: getBrandId(state),
});

export default compose(
  connect(mapStateToProps),
  withPermissions,
)(BrandUserSettingsWrapper);
